'use client';

import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import type { AddressesPageInterface } from '../AddAddressForm/types';
import { ExperianModalCore } from './ExperianModalCore';
import type { ExperianModalType, FormProps } from './types';

export function ExperianModalRHF({
    experianResponse,
    saveSelectedAddress,
    loading,
    setIsLoading,
    onEditAddressClick,
    onVisibilityChange,
    onSaveError,
}: Readonly<ExperianModalType>) {
    const { control, setValue } = useFormContext<AddressesPageInterface>();
    const [firstName, lastName, phone, address, isPrimary, petPreferences, useForAllShipments] = useWatch({
        control,
        name: ['firstName', 'lastName', 'phone', 'address', 'isPrimary', 'petPreferences', 'useForAllShipments'],
    });

    const currentFormValues = useMemo(
        () =>
            ({
                firstName: firstName ?? '',
                lastName: lastName ?? '',
                phone: phone ?? '',
                address: address ?? {
                    streetAddress: '',
                    apt: '',
                    city: '',
                    state: '',
                    zipCode: '',
                },
                isPrimary: isPrimary ?? false,
                petPreferences: petPreferences ?? {},
                useForAllShipments: useForAllShipments ?? false,
                addressType: 'form',
            }) as FormProps,
        [address, firstName, isPrimary, lastName, petPreferences, phone, useForAllShipments]
    );

    const setCurrentFormValues = (values: FormProps) => {
        setValue('firstName', values.firstName);
        setValue('lastName', values.lastName);
        setValue('phone', values.phone ?? '');
        setValue('address', values.address);
        setValue('isPrimary', values.isPrimary ?? false);
        setValue('petPreferences', values.petPreferences ?? {});
    };

    return (
        <ExperianModalCore
            experianResponse={experianResponse}
            saveSelectedAddress={saveSelectedAddress}
            loading={loading}
            setIsLoading={setIsLoading}
            onEditAddressClick={onEditAddressClick}
            onVisibilityChange={onVisibilityChange}
            onSaveError={onSaveError}
            currentFormValues={currentFormValues}
            setCurrentFormValues={setCurrentFormValues}
        />
    );
}
